import { useFormContext } from 'react-hook-form';

import { ExamOverview } from '../../containers';
import { useNewExamFormOptional } from '../../providers';
import { useExamPreviewFormOptional } from '../../providers/exam-preview';

export default function ExamReview() {
  const formContext = useFormContext();
  const newExamFormContext = useNewExamFormOptional();
  const previewFormContext = useExamPreviewFormOptional();

  const submitContext = newExamFormContext || previewFormContext;

  if (!submitContext) {
    throw new Error(
      'ExamReview must be used within either NewExamFormProvider or ExamPreviewFormProvider',
    );
  }

  const { getValues } = formContext;
  const answer = getValues();

  return (
    <div className='flex-1 overflow-y-auto'>
      <div className='flex h-full justify-center'>
        <ExamOverview answer={answer} />
      </div>
    </div>
  );
}
